import {
  CATEGORY_LABEL_TEXT_MOBILE_DESIGN_PARAMS,
  CATEGORY_LABEL_LAYOUTS,
  CATEGORY_LABEL_LAYOUT_PATH,
  CATEGORY_LABEL_TEXT_DESIGN_PARAMS,
  CATEGORY_LABEL_BUTTON_DESIGN_PARAMS,
  CATEGORY_LABEL_LAYOUT_MOBILE_PATH,
  CATEGORY_LABEL_BUTTON_MOBILE_DESIGN_PARAMS,
  CATEGORY_LABEL_MOBILE_DESIGN_TOGGLE,
} from '@wix/communities-blog-client-common';

import { getAppSettingsValue } from '../../common/selectors/app-settings-base-selectors';
import { getIsMobileSettingEnabled } from '../../common/selectors/mobile-settings-selectors';
import { getIsMobile } from '../../common/store/basic-params/basic-params-selectors';
import { type AppState } from '../../common/types';

export const shouldUseMobileSettings = (state: AppState) =>
  getIsMobile(state) &&
  getIsMobileSettingEnabled(state, CATEGORY_LABEL_MOBILE_DESIGN_TOGGLE.appSettingsPath);

const getCategoryLabelLayout = (state: AppState) =>
  getAppSettingsValue({
    state,
    key: shouldUseMobileSettings(state)
      ? CATEGORY_LABEL_LAYOUT_MOBILE_PATH
      : CATEGORY_LABEL_LAYOUT_PATH,
    fallback: CATEGORY_LABEL_LAYOUTS.text,
  });

export const getIsCategoryLabelLayoutText = (state: AppState) =>
  getCategoryLabelLayout(state) === CATEGORY_LABEL_LAYOUTS.text;

const getCategoryLabelParamsByDeviceType = (state: AppState) => {
  const useMobileSettings = shouldUseMobileSettings(state);
  const categoryLabelLayout = getCategoryLabelLayout(state);

  return {
    [CATEGORY_LABEL_LAYOUTS.text]: useMobileSettings
      ? CATEGORY_LABEL_TEXT_MOBILE_DESIGN_PARAMS
      : CATEGORY_LABEL_TEXT_DESIGN_PARAMS,
    [CATEGORY_LABEL_LAYOUTS.button]: useMobileSettings
      ? CATEGORY_LABEL_BUTTON_MOBILE_DESIGN_PARAMS
      : CATEGORY_LABEL_BUTTON_DESIGN_PARAMS,
  }[categoryLabelLayout];
};

const createCategoryLabelSettingsSelector =
  (param: string, defaultValueName: string) => (state: AppState) => {
    const params = getCategoryLabelParamsByDeviceType(state) as any;
    return getAppSettingsValue({
      state,
      key: params[param].appSettingsPath,
      fallback: params[param][defaultValueName],
    });
  };

export const getCategoryLabelTextFont = (state: AppState) => {
  const { textFont } = getCategoryLabelParamsByDeviceType(state) as any;
  const font = getAppSettingsValue({ state, key: textFont.appSettingsPath });
  return (
    font || {
      size: textFont.defaultSize,
    }
  );
};

export const getCategoryLabelVerticalPadding = createCategoryLabelSettingsSelector(
  'verticalPadding',
  'defaultPadding',
);
export const getCategoryLabelBorderWidth = createCategoryLabelSettingsSelector(
  'borderWidth',
  'defaultWidth',
);
export const getIsCategoryLabelUppercase = createCategoryLabelSettingsSelector(
  'uppercase',
  'defaultValue',
);
